import moment from "moment";

export const initialValues = {
    company: "ООО ХКТ",
    user: "ss",
    created_at: moment().format("DD.MM.YYYY"),
    expired_at: "",
    balance: "",
    name: "",
}